import { createSelector } from 'reselect';

export const assetClassesSelector = state => state.AdviserSettings.AssetClasses;

export const hasLoadedSelector = createSelector(
  assetClassesSelector,
  ({ hasLoaded }) => hasLoaded,
);

export const assetClassesOptionsSelector = createSelector(
  assetClassesSelector,
  ({ options }) => options,
);

export const assetClassesMappingSelector = createSelector(
  assetClassesSelector,
  ({ mapping }) => mapping,
);
